module.exports = __webpack_public_path__ + "static/img/icon-form-m_07.ce28c185.svg";